module.exports = __webpack_public_path__ + "img/goeatLogo_w.572d1585.png";